import { BoxProps, ColorOptions, TextNewProps, TextProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import { Colors } from '../../util/util'

export const shadow = {
  shadowColor: '#00000029' as ColorOptions,
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.8,
  shadowRadius: 4,
  elevation: 3,
}

export const styles = {
  container: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 5,
    shadowColor: Colors.LIGHT_GREY,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.BORDER_COLOR,
    zIndex: 10,
    flex: 1,
    marginVertical: 16,
    marginHorizontal: 16,
    backgroundColor: 'WHITE',
    paddingHorizontal: 16,
    paddingVertical: 16,
    overflowY: "auto",
  } as BoxProps,
  titleText: {
    fontSize: 20,
    color: 'BLACK_21' as ColorOptions,
    textAlign: 'left',
    fontFamily: 'jiotype-medium',
  } as TextNewProps,
  flexRowView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    pb: 16,
  } as BoxProps,
  emptyContainer: {
    alignContent: 'center',
    flex: 1,
  } as BoxProps,
  tableContainer: () =>
    ({
      alignContent: 'center',
      flexGrow: 1,
    } as BoxProps),
}

const DefaultStyle = {
  container: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: Colors.LIGHT_GREY,
    borderWidth: 1,
    borderColor: Colors.BORDER_COLOR,
    zIndex: 10,
    backgroundColor: 'WHITE',
    padding: 16,
    marginHorizontal: 18,
    border: `1px solid ${Colors.SECONDARY_GREY}`,
    justifyContent: 'space-between',
    borderRadius: 4,
    position: 'relative',
    flexGrow: 1,
  } as BoxProps,
  tableContainer: (isLoading: boolean) =>
    ({
      alignContent: 'center',
      flexGrow: 1,
      marginTop: isLoading ? 24 : undefined,
    } as ViewStyle),
  emptyContainer: {
    alignContent: 'center',
    flex: 1,
  } as ViewStyle,
}

export const stylesFile = (breakpoint: number): any => {
  const isMobile = breakpoint < 560
  const isExtraaSmall = breakpoint <= 320
  return {
    scrollContainer: {
      flexGrow: 1,
    },
    maincontainer: {
      margin: isMobile ? 0 : 16,
      flex: 1,
      backgroundColor: 'BACKGROUND',
    } as BoxProps,
    mainContainerWeb: {
      marginHorizontal: 16,
      overflow: 'auto',
      maxHeight: '80vh',
      position: 'relative',
      marginTop: 16,
      paddingBottom: 40,
    } as BoxProps,
    aligncenter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      paddingBottom: 16,
      margin: 16,
    } as BoxProps,
    tabbar: {
      backgroundColor: 'white',
      marginTop: 20,
      paddingLeft: 16,
      marginRight: 'auto',
      width: '100%',
      height: 48,
    } as ViewStyle,
    transactions: {
      ...DefaultStyle,
    },
    settlements: {
      ...DefaultStyle,
    },
    refunds: {
      ...DefaultStyle,
    },
    disputes: {
      ...DefaultStyle,
    },
    topBar: {
      flexDirection: 'row',
      justifyContent: isMobile ? 'flex-start' : 'space-between',
      zIndex: 12,
      // flex: 1,
      flexWrap: 'wrap',
    } as BoxProps,
    mobileSelectionFix: {
      marginRight: isMobile ? 10 : 0,
      display: 'flex',
      borderWidth: 1,
      flex: 1,
      flexWrap: 'wrap',
      flexDirection: 'row',
      borderColor: 'TRANSPARENT',
    } as BoxProps,
    popupFieldSettings: {
      flex: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: Colors.MODAL_SHADOW,
      zIndex: 1,
    } as ViewStyle,
    stickyHeader: {
      position: 'sticky',
      top: -2,
      paddingVertical: 16,
      backgroundColor: 'white',
      zIndex: 100,
      marginTop: -16,
    } as unknown as BoxProps,
    popupBody: {
      borderColor: Colors.WHITE,
      backgroundColor: Colors.WHITE,
      shadowOpacity: 0.6,
      shadowRadius: 5,
      borderRadius: 8,
    } as ViewStyle,

    refundBody: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
    } as ViewStyle,

    errorView: {
      textAlign: 'center',
      margin: 8,
      color: 'RED',
    } as TextProps,

    loadingView: { width: '100%', textAlign: 'center' } as TextProps,

    hoverlistHeaderContainer: {
      flex: 1,
      flexDirection: 'row',
      // Todo
      backgroundColor: '#F8F8F8',
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 24,
      paddingRight: 24,
    } as ViewStyle,

    listItemContainer: {
      flex: 1,
      flexDirection: 'row',
      paddingTop: 16,
      paddingLeft: 24,
      paddingRight: 24,
    } as ViewStyle,

    listItemText: {
      minWidth: 100,
      maxWidth: 100,
      fontSize: 12,
      fontWeight: 'MEDIUM',
      color: 'BLACK_21',
      paddingRight: 16,
    } as TextProps,
    dateSelectorContainer: {
      flexDirection: 'row',
      marginTop: 20,
      flexWrap: 'wrap',
      maxWidth: '100%',
      justifyContent: 'flex-start',
    } as BoxProps,
    hoverHeaderText: {
      minWidth: 100,
      maxWidth: 100,
      fontSize: 10,
      fontWeight: 'MEDIUM',
      color: 'PRIMARY_GREY',
      paddingRight: 16,
    } as TextProps,
    container: {
      shadowColor: Colors.BLACK,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.4,
      shadowRadius: 8,
      elevation: 5,
      overflow: 'hidden',
      borderRadius: 4,
      flex: 1,
      backgroundColor: Colors.WHITE,
      borderWidth: 1,
      borderColor: Colors.BORDER_COLOR,
    } as ViewStyle,
    textLayout: {
      flex: 1,
      justifyContent: 'flex-start',
      flexDirection: 'row',
      padding: 0,
      margin: 0,
    } as ViewStyle,
    rowContainer: {
      flexDirection: 'row',
      marginTop: 20,
      minWidth: isMobile ? '100%' : 10,
      maxWidth: '100%',
      alignItems: 'center',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
    } as BoxProps,
    generateContainer: {
      marginTop: isMobile ? 24 : 0,
      minHeight: 36,
    } as BoxProps,
    hoverHeader: {
      padding: 24,
    } as ViewStyle,
    hoverDetails: {
      flex: 1,
      flexDirection: 'row',
      margin: 24,
      padding: 0,
    } as ViewStyle,
    hoverColumn: {
      flex: 1,
      flexDirection: 'column',
      margin: 0,
      padding: 0,
    } as ViewStyle,
    modalList: {
      backgroundColor: 'WHITE',
      position: 'relative',
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
    } as BoxProps,
    modalListItem: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: 20,
      paddingVertical: 20,
      borderBottomWidth: 1,
      borderBottomColor: 'GREY_SEPARATOR',
      underlayColor: 'TRANSPARENT',
    } as BoxProps,
    bars: {
      backgroundColor: 'WHITE',
      padding: 8,
      marginTop: isExtraaSmall ? 20 : 0,
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      shadowColor: Colors.LIGHT_GREY,
      borderRadius: 4,
      zIndex: 4,
    } as BoxProps,
    buttonContainer: {
      paddingHorizontal: 10,
      paddingVertical: 10,
    } as BoxProps,
    settlmentNote: {
      marginLeft: 16,
    } as BoxProps,
    refreshButton: {
      w: 80,
      backgroundColor: 'WHITE',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
      paddingHorizontal: 8,
      paddingVertical: 5,
      borderColor: 'DISABLED_GREY',
      borderWidth: 1,
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
    } as BoxProps,
  }
}
